import { useEffect, useState, useRef } from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { TablePaginate } from "../../../layout/Datagrid/TablePaginate";
import { useNavigate, useParams } from "react-router-dom";
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import { flujoEnum } from "../../../types/enumTypes";
import getColumnsVerificacionAE from "../../../layout/Columns/ColumnsVerificacionMontosAE";
import * as XLSX from 'xlsx';
import { EditarTituloAE, FlujoMontosAE, mostrarDatosDetalleAE } from "../../../services/PpafeServicesAE";
import { Download } from "@mui/icons-material";
import { puedeActualizar } from "../../../utils/permisosFlujo";
import Swal from "sweetalert2";


const VerifiacionMontosAE = () => {
    const { id } = useParams<{ id: string }>();
    const [titulo, setTitulo] = useState<string>("");
    const [currentPage, setCurrentPage] = React.useState(1);
    const [perPage, setPerPage] = React.useState(25);
    const [dataLoading, setDataLoading] = useState(false);
    const navigate = useNavigate();
    const [estatus, setEstatus] = useState<flujoEnum>(flujoEnum.oculto); // Nuevo estado para el estatus
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [responseData, setResponseData] = useState<any[]>([]);
    const scrollRef = useRef<HTMLDivElement>(null);
    const [modoEdicionTitulo, setModoEdicionTitulo] = useState(false);

    useEffect(() => {
        if (responseData.length > 0) {
            scrollRef.current?.scrollIntoView({ behavior: "smooth" });
        }
    }, [responseData]);


    const handleVerClick = (id: string, link: string) => {
        navigate("/" + link + "/alta/" + id);
    };

    const columns = getColumnsVerificacionAE({ handleVerClick, urlOrigen: '/usuarios/listado', rows: Array.isArray(responseData) ? responseData : [] });

    const flujoDetalle = (accion: "avanzar" | "devolver") => {
        const tipo = "aportaciones";
        const origen = "estatales";
        FlujoMontosAE(tipo, origen, setLoading, setResponseData, setError, estatus, id || "", accion);
    };

    const editar = (callback?: () => void) => {
        const tipo = "aportaciones";
        const origen = "estatales";
        EditarTituloAE(tipo, origen, setLoading, setResponseData, ObtenerDatosDetalle, setError, id || "", titulo);
    };

    const ObtenerDatosDetalle = () => {
        const tipo = "aportaciones"; // Aquí puedes cambiarlo dinámicamente
        const origen = "estatales"; // También puedes pasarlo según la pantalla
        mostrarDatosDetalleAE(tipo, origen, setLoading, setResponseData, setError, setTitulo, setEstatus, id || "");
    };

    useEffect(() => {
        ObtenerDatosDetalle();

    }, []); // Dependencias vacías para ejecutarse solo al montar el componente

    const getEstatusCorrecto = (estatus: string) => {
        const estatusLower = estatus.toLowerCase(); // Convertimos todo a minúsculas
        switch (estatusLower) {
            case "revision":
                return "Revisión";
            case "validacion":
                return "Validación";
            case "publicado":
                return "Publicado";
            case "devuelto":
                return "Devuelto";
            case "oculto":
                return "Oculto";
            default:
                return estatus.toUpperCase(); // En caso de que el estatus no esté en los casos anteriores
        }
    };

    const obtenerTextoBoton = () => {
        switch (estatus) {
            case "REVISION":
                return "Validar";
            case "VALIDACION":
                return "Publicar";
            case "PUBLICADO":
                return "Publicado"; // O puedes devolver un texto diferente si es necesario
            case "OCULTO":
                return "revisar";
            case "DEVUELTO":
                return "revisar";
            default:
                return "Guardar"; // Si no hay estatus, por defecto
        }
    };

    const TITULO = estatus ? `${getEstatusCorrecto(estatus)} de Montos` : "Validación de Montos";

    const exportToExcel = () => {
        if (!responseData || responseData.length === 0) {
            console.warn("No hay datos para exportar.");
            return;
        }
        // Definir los encabezados personalizados
        const formatNumber = (num: string | number | null | undefined) => {
            if (num === undefined || num === null || num === "") return "0.00";
            // Si es string, quitar comas y convertir a número
            if (typeof num === 'string') {
                num = num.replace(/,/g, '');
                num = parseFloat(num);
            }
            // Si es número válido, formatear
            return !isNaN(num)
                ? num.toFixed(2) // <- Aquí se evita el uso de toLocaleString
                : "0.00";
        };
        const tituloReporte = [[titulo]];
        // 🔹 Mapear los datos asegurando que coincidan con los encabezados
        const allColumns = [
            { field: "municipio", header: "Municipios" },
            { field: "FOULT", header: "Fondo de Ultracrecimiento Municipal" },
            { field: "FODES", header: "Fondos Descentralizados" },
            { field: "FOSEGMUN", header: "Fondos de Seguridad para los Municipios" },
            { field: "FOINMUN", header: "Fondo de Infraestructura para los Municipios" },
            { field: "total_monto", header: "Totales" }
        ];
        // 🔥 Filtrar columnas donde NO sean todos ceros
        const validColumns = allColumns.filter(({ field }) => {
            // municipio siempre debe incluirse
            if (field === "municipio") return true;
            // Validar que haya algún dato diferente de 0 para esta columna
            return responseData.some(item => {
                const value = item[field];
                if (value === undefined || value === null || value === "") return false;
                let numericValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
                // Si no es un número, no lo consideramos
                if (isNaN(numericValue)) return false;
                // Solo es válido si es distinto de cero
                return numericValue !== 0;
            });
        });
        // Crear encabezados dinámicos basados en columnas válidas
        const headers = [validColumns.map(col => col.header)];
        // Mapear los datos asegurando que coincidan con los encabezados válidos
        const formattedData = responseData.map((item) =>
            validColumns.map(({ field }) => {
                if (field === "municipio") return item.municipio || "";
                return formatNumber(item[field]);
            })
        );
        // Crear hoja de Excel con los datos obtenidos
        const ws = XLSX.utils.aoa_to_sheet([...tituloReporte, ...headers, ...formattedData]);
        ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers[0].length - 1 } }];
        ws["A1"].s = {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center" }
        };
        ws['!cols'] = Array(headers[0].length).fill({ wch: 25 });
        // Crear un libro de trabajo y agregar la hoja
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Datos");
        // Escribir el archivo en un Blob
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        // Crear un enlace de descarga y activarlo automáticamente
        const fileName = "Reporte_Datos.xlsx";
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        // Limpiar memoria
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };



    return (

        <Grid container sx={{}}>
            <Grid item mb={2} width={"100%"}>
                <BreadcrumbBar
                    links={[
                        { texto: "Inicio", link: "/admin" },
                        { texto: "Montos", link: "/admin/aportaciones/estatales/montos" },
                    ]}
                    Titulo={TITULO}
                />
            </Grid>
            <Grid item mb={2} width={"100%"} >
                <Typography
                    variant="h5"
                    component="div"
                    sx={{
                        flexGrow: 1,
                        fontWeight: "bold",
                        display: "flex",
                        justifyContent: "left",
                    }}
                >
                    {estatus ? `${getEstatusCorrecto(estatus)} de Montos` : "de Montos"}
                </Typography>

                <Grid item width={"100%"}>
                    {estatus === "DEVUELTO" && modoEdicionTitulo ? (
                        <TextField
                            variant="outlined"
                            fullWidth
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                            sx={{
                                fontWeight: "bold",
                            }}
                        />
                    ) : (
                        <Typography
                            variant="h5"
                            component="div"
                            sx={{
                                flexGrow: 1,
                                fontWeight: "bold",
                                display: "flex",
                                justifyContent: "left",
                            }}
                        >
                            {titulo}
                        </Typography>
                    )}
                </Grid>
            </Grid>

            <Grid
                container
                spacing={2}
                justifyContent="space-between"
                alignItems="center"
                sx={{ mb: 2 }}
            >
                <Grid
                    item
                    xs={12}
                    md="auto"
                    display="flex"
                    justifyContent={{ xs: "center", md: "flex-start" }}
                    width="100%"
                >
                    <Button
                        startIcon={<Download />}
                        onClick={exportToExcel}
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                            maxWidth: { xs: "100%", md: "auto" }, // ocupa todo el ancho en celular
                        }}
                    >
                        Exportar a Excel
                    </Button>
                </Grid>

                <Grid
                    item
                    xs={12}
                    md="auto"
                    display="flex"
                    justifyContent={{ xs: "center", md: "flex-end" }}
                    width="100%"
                >
                    {estatus === "DEVUELTO" && (
                        <Button
                            onClick={() => {
                                if (modoEdicionTitulo) {
                                    editar(); // Solo ejecuta editar cuando ya se está editando
                                    setModoEdicionTitulo(false);
                                } else {
                                    setModoEdicionTitulo(true); // Activa modo edición
                                }
                            }}
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{
                                maxWidth: { xs: "100%", md: "auto" }, // ocupa todo el ancho en celular
                            }}
                        >
                            {modoEdicionTitulo ? "Guardar Titulo" : "Editar Titulo"}
                        </Button>
                    )}
                </Grid>
            </Grid>
            <TablePaginate
                rowsInfo={responseData}
                columns={columns}
                Mostrar={false}
                loading={dataLoading}
            />
            <Grid
                container
                spacing={2}
                sx={{ mt: 2 }}
                justifyContent={{ xs: "center", md: "flex-end" }}
            >
                <Grid
                    item
                    xs={12}
                    md="auto"
                    display="flex"
                    justifyContent={{ xs: "center", md: "flex-end" }}
                >
                    <Button
                        sx={{
                            width: { xs: "100%", md: "7rem" },
                            textTransform: "capitalize",
                        }}
                        variant="contained"
                        onClick={() =>
                            navigate("/admin/aportaciones/estatales/montos")
                        }
                        style={{ backgroundColor: "#C1A25C" }}
                    >
                        Cancelar
                    </Button>
                </Grid>

                {puedeActualizar(estatus) && (
                    <Grid
                        item
                        xs={12}
                        md="auto"
                        display="flex"
                        justifyContent={{ xs: "center", md: "flex-end" }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{
                                width: { xs: "100%", md: "7rem" },
                                textTransform: "capitalize",
                            }}
                            disabled={
                                estatus === "OCULTO" ||
                                estatus === "DEVUELTO"
                            }
                            onClick={() => flujoDetalle("devolver")}
                        >
                            Devolver
                        </Button>
                    </Grid>
                )}

                {puedeActualizar(estatus) && (
                    <Grid
                        item
                        xs={12}
                        md="auto"
                        display="flex"
                        justifyContent={{ xs: "center", md: "flex-end" }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            sx={{
                                width: { xs: "100%", md: "7rem" },
                                textTransform: "capitalize",
                            }}
                            disabled={
                                estatus === "PUBLICADO"
                            }
                            onClick={() => flujoDetalle("avanzar")}
                        >
                            {obtenerTextoBoton()}
                        </Button>
                    </Grid>
                )}
            </Grid>
            <div ref={scrollRef} />
        </Grid >
    );
};

export default VerifiacionMontosAE;
